import React from "react";
import ContentRecoverPassword from "./Content/ContentRecoverPassword";

const RedefinirSenha = () => {
  return (
    <div>
      <ContentRecoverPassword />
    </div>
  );
};

export default RedefinirSenha;
